import i18n from "i18next";
import { Trans, initReactI18next } from "react-i18next";
import translation from "./data/contentData.json";

i18n.use(initReactI18next).init({
  lng: "ru",
  fallbackLng: "ru",
  interpolation: {
    escapeValue: false,
    defaultVariables: {
      city: translation.city,
      name: translation.name,
      adress: translation.adress,
      email: translation.email,
      phone: translation.phone,
    },
  },
  resources: {
    ru: {
      translation: {
        name: "Лапшина Ирина Анатольевна",
        city: "Наро-Фоминск",
        adress: "г. Наро-Фоминск, ул. Ленина, д. 18",
        phone: "+7 (916) 332-82-59",
        email: "laptshka@mail.ru",
        home: {
          title: "Частный юрист в Наро-Фоминске",
          description:
            "Профессиональная юридическая помощь в Наро-Фоминске. Консультации по гражданскому, семейному, жилищному, земельному, трудовому праву и защите прав потребителей.",
          keywords: {
            k1: "частный юрист {{city}}",
            k2: "юридическая консультация {{city}}",
            k3: "семейное право {{city}}",
            k4: "жилищное право {{city}}",
            k5: "трудовое право {{city}}",
            k6: "защита прав потребителей {{city}}",
          },
          text: "Здравствуйте! Меня зовут {{name}}, я — опытный частный юрист в Наро-Фоминске. Предоставляю квалифицированную юридическую помощь гражданам и организациям по широкому спектру вопросов: от семейных и жилищных споров до защиты прав потребителей и трудовых споров. Мой опыт и индивидуальный подход к каждому делу помогают эффективно решать юридические проблемы и защищать интересы клиентов.",
        },
        services: {
          zhilishchnoye: {
            title: "Жилищное  право в Наро-Фоминске – помощь юриста",
            description:
              "Юрист в Наро-Фоминске решает жилищные споры: вселение, выселение, признание сделок недействительными, определение доли и порядок пользования жильем.",
            keywords: {
              k1: "жилищное право {{city}}",
              k2: "вселение в квартиру {{city}}",
              k3: "выселение из квартиры {{city}}",
              k4: "раздел жилого помещения {{city}}",
              k5: "признание сделок с недвижимостью недействительными {{city}}",
              k6: "юрист по жилищным спорам {{city}}",
            },
            text: "В  жизни нередко возникают ситуации, когда совместное проживание в одной квартире становится невозможным. Бывший член семьи отказывается освободить жильё, либо проживает в другом месте и не платит за коммунальные услуги, оставаясь при этом зарегистрированным в квартире. Также возможны споры между собственниками и нанимателями о порядке пользования жилым помещением. Все эти вопросы требуют грамотного решения в судебном порядке при помощи квалифицированного юриста.",
            bulletPoints: [
              "Признание сделок с недвижимостью (купля-продажа, мена, дарение, рента с пожизненным содержанием) недействительными",
              "Вселение и выселение из жилых помещений, включая бывших членов семьи собственника или нанимателя",
              "Прекращение права пользования жилым помещением, снятие с регистрационного учета",
              "Признание права на жилое помещение",
              "Признание утратившим право пользования жилым помещением",
              "Истребование имущества из чужого незаконного владения",
              "Урегулирование споров между гражданами и ЖСК",
              "Раздел жилого помещения и определение доли в праве собственности",
              "Определение порядка пользования жилым помещением",
              "Возмещение ущерба при заливе квартиры",
              "Другие вопросы жилищного права",
            ],
            text2:
              "Я имею многолетний опыт работы с жилищными спорами и помогу вам защитить ваши права как собственника или нанимателя. Консультация юриста позволит избежать ошибок и ускорить решение вопросов через суд или досудебное урегулирование.",
            button: "Жилищное право",
          },
          zemelnoe: {
            title:
              "Земельные споры и оформление прав собственности – юрист в Наро-Фоминске",
            description:
              "Опытный юрист в Наро-Фоминске решает земельные споры: установление границ, раздел участка, признание права собственности, оформление земли.",
            keywords: {
              k1: "земельные споры {{city}}",
              k2: "признание права собственности на землю {{city}}",
              k3: "установление границ земельного участка {{city}}",
              k4: "раздел земельного участка {{city}}",
              k5: "оформление земельных участков {{city}}",
              k6: "юрист по земельным вопросам {{city}}",
            },
            text: "Сегодня понятие собственности на землю становится всё более актуальным и часто становится предметом споров между физическими лицами, юридическими организациями, органами местного самоуправления и государственными структурами. Признание права собственности на земельный участок нередко осуществляется в судебном порядке. Кроме того, в практике часто встречаются конфликты между соседями в деревнях, садовых товариществах или дачных кооперативах — от несогласия с существующими границами до нарушений при строительстве. В таких ситуациях помощь квалифицированного юриста по земельным вопросам обеспечивает законное и справедливое решение.",
            bulletPoints: [
              "Признание права собственности на земельный участок",
              "Определение порядка пользования земельным участком",
              "Выдел доли и раздел земельного участка",
              "Установление границ земельного участка",
              "Снятие и постановка на государственный кадастровый учет земельного участка",
              "Оформление прав собственности на земельные участки",
              "Снос незаконно возведённых строений, нарушающих границы вашего участка",
              "Другие вопросы, связанные с земельными спорами",
            ],
            text2:
              "Я имею многолетний опыт работы с делами о земельных правах и спорах. Помогу вам грамотно оформить собственность на землю, защитить свои интересы и добиться справедливого решения в суде. Консультация юриста по земельным вопросам позволит избежать юридических ошибок и сэкономить ваше время.",
            button: "Земельное право",
          },
          semeinoe: {
            title:
              "Семейные споры и развод – юрист по семейным делам в Наро-Фоминске",
            description:
              "Опытный юрист по семейным делам в Наро-Фоминске: развод, алименты, раздел имущества, определение места жительства ребенка и другие семейные споры.",
            keywords: {
              k1: "семейные споры {{city}}",
              k2: "развод {{city}}",
              k3: "алименты {{city}}",
              k4: "раздел имущества супругов {{city}}",
              k5: "лишение родительских прав {{city}}",
              k6: "юрист по семейным делам {{city}}",
              k7: "установление отцовства {{city}}",
            },

            text: "Семейные споры – это одна из самых сложных и эмоционально напряжённых категорий дел. Развод, раздел имущества, взыскание алиментов, определение места жительства ребёнка – все эти вопросы требуют не только юридической грамотности, но и такта, умения сохранять объективность и эмоциональную устойчивость. Часто бывшие супруги не могут трезво оценить ситуацию и принимают решения под влиянием эмоций, что может привести к серьёзным ошибкам в суде. Опытный юрист по семейным делам поможет вам грамотно защитить свои интересы, минимизировать стресс и добиться справедливого решения.",
            bulletPoints: [
              "Расторжение брачных отношений (развод)",
              "Раздел совместно нажитого имущества супругов",
              "Раздел долгов по кредитным договорам, заключённым в период брака",
              "Взыскание алиментов (в том числе в твёрдой денежной сумме) на содержание детей, жены или бывшей жены",
              "Снижение размера алиментов",
              "Лишение родительских прав",
              "Определение места жительства ребёнка",
              "Определение порядка общения с ребёнком",
              "Установление отцовства",
              "Оспаривание отцовства",
              "Другие семейные споры",
            ],
            text2:
              "Я имею многолетний опыт в разрешении семейных споров и защите интересов клиентов в судах Наро-Фоминска и Московской области. Обращаясь ко мне, вы получите квалифицированную юридическую помощь по вопросам развода, раздела имущества, алиментов и прав на детей. Консультация юриста по семейным делам поможет вам избежать ошибок и сохранить эмоциональное равновесие.",
            button: "Семейное право",
          },
          nasledstvo: {
            title: "Наследственные споры – юрист по наследству в Наро-Фоминске",
            description:
              "Юрист по наследственным делам в Наро-Фоминске: помощь при вступлении в наследство, оформлении документов, спорах о наследстве и оспаривании завещания.",
            keywords: {
              k1: "наследственные споры {{city}}",
              k2: "юрист по наследству {{city}}",
              k3: "вступление в наследство {{city}}",
              k4: "оспаривание завещания {{city}}",
              k5: "раздел наследства {{city}}",
              k6: "право на обязательную долю",
              k7: "принятие наследства",
              k8: "наследственные дела Московская область",
            },
            text: "Наследственное право — это одна из самых сложных областей гражданского права. Очереди наследования, право на обязательную долю, наследственная трансмиссия, определение круга правопреемников — всё это требует глубоких знаний законодательства и судебной практики. После смерти наследодателя часто возникают ситуации, когда наследники не оформляют свои права на имущество, пропуская установленный законом срок для принятия наследства. Нотариусы также могут отказывать в выдаче свидетельства о праве на наследство. В таких случаях помощь опытного юриста по наследственным делам становится необходимой.",
            bulletPoints: [
              "Вступление в наследство и оформление документов",
              "Установление факта принятия наследства",
              "Признание права собственности в порядке наследования",
              "Признание права на обязательную долю в наследстве",
              "Оспаривание завещания в суде",
              "Раздел наследственного имущества",
              "Решение других наследственных споров",
            ],
            text2:
              "Я оказываю квалифицированную юридическую помощь в оформлении наследственных прав, восстановлении сроков принятия наследства и разрешении наследственных споров. Опыт более 10 лет позволяет мне эффективно защищать интересы клиентов в судах Наро-Фоминска и Московской области. Обращаясь за консультацией, вы получите профессиональную поддержку и уверенность в законности своих действий.",
            button: "Наследственное право",
          },
          trudovyeSpory: {
            title: "Трудовые споры – юрист по трудовому праву в Наро-Фоминске",
            description:
              "Юрист по трудовым спорам в Наро-Фоминске: защита прав работников и работодателей, незаконное увольнение, невыплата зарплаты, восстановление на работе.",
            keywords: {
              k1: "трудовые споры {{city}}",
              k2: "юрист по трудовым делам {{city}}",
              k3: "незаконное увольнение {{city}}",
              k4: "восстановление на работе {{city}}",
              k5: "невыплата заработной платы",
              k6: "трудовые права работника",
              k7: "споры с работодателем",
              k8: "юрист по трудовому праву Московская область",
            },
            text: "Нарушения трудовых прав в наше время — не редкость. Работодатели нередко нарушают закон, увольняя сотрудников без законных оснований или задерживая выплату заработной платы. Также встречаются случаи, когда работник сам нарушает трудовые обязательства, создавая конфликтные ситуации. В подобных вопросах важно действовать грамотно и своевременно, чтобы защитить свои права и интересы.",
            bulletPoints: [
              "Восстановление на работе после незаконного увольнения",
              "Установление факта трудовых отношений",
              "Оспаривание дисциплинарных взысканий",
              "Взыскание заработной платы и компенсации за задержку выплат",
              "Взыскание компенсаций при увольнении",
              "Взыскание с работника материального ущерба",
              "Подтверждение трудового стажа для назначения пенсии или досрочной пенсии",
              "Решение других трудовых споров",
            ],
            text2:
              "Я оказываю квалифицированную юридическую помощь работникам и работодателям в сфере трудового права: консультирую, подготавливаю документы и представляю интересы в суде. Мой опыт позволяет эффективно защищать права клиентов при незаконном увольнении, невыплате заработной платы, спорных дисциплинарных взысканиях и других нарушениях. Помогу вам добиться восстановления справедливости и законного результата в Наро-Фоминске и Московской области.",
            button: "Трудовые споры",
          },
          strakhovyye: {
            title:
              "Страховые споры – помощь юриста по страховым делам в Наро-Фоминске",
            description:
              "Юридическая помощь при страховых спорах в Наро-Фоминске: отказ в выплате, занижение суммы страхового возмещения, досудебное и судебное урегулирование.",
            keywords: {
              k1: "страховые споры {{city}}",
              k2: "юрист по страховым делам {{city}}",
              k3: "оспаривание отказа в выплате страховки",
              k4: "взыскание страхового возмещения",
              k5: "спор со страховой компанией",
              k6: "страховое возмещение после ДТП",
              k7: "КАСКО ОСАГО юрист {{city}}",
              k8: "досудебное урегулирование страховых споров",
              k9: "страховые выплаты Московская область",
            },
            text: "По данным Российского союза автостраховщиков (РСА), каждая пятая страховая компания отказывает в выплате возмещения по заявлениям клиентов. После ДТП страховые организации часто занижают сумму компенсации, применяя завышенный износ автомобиля, не учитывая скрытые повреждения или вовсе отказывая в выплате. Основная цель страховщиков — минимизация расходов, поэтому добиться справедливости без юридической поддержки бывает крайне сложно. Я помогу защитить ваши права и получить положенную по закону выплату.",
            bulletPoints: [
              "Досудебное урегулирование споров со страховой компанией",
              "Разрешение страхового спора в суде",
            ],
            text2:
              "На каждом этапе урегулирования страховых споров я подбираю наиболее эффективные правовые инструменты, опираясь на особенности конкретной ситуации и судебную практику. Моя помощь позволит вам добиться справедливого возмещения и минимизировать стресс, связанный с конфликтом со страховой компанией. Работаю с делами по ОСАГО, КАСКО и другим видам страхования в Наро-Фоминске и Московской области.",
            button: "Страховые споры",
          },
          other: {
            title:
              "Другие юридические услуги в Наро-Фоминске – консультации и правовая помощь",
            description:
              "Юридические услуги в Наро-Фоминске: взыскание долгов, оформление наследства, составление договоров, правовая экспертиза и приватизация жилья.",
            keywords: {
              k1: "юридические услуги {{city}}",
              k2: "взыскание долгов {{city}}",
              k3: "правовая помощь {{city}}",
              k4: "юрист по гражданским делам {{city}}",
              k5: "составление договоров {{city}}",
              k6: "приватизация жилья {{city}}",
              k7: "правовая экспертиза документов",
              k8: "консультация юриста {{city}}",
              k9: "оформление наследства {{city}}",
              k10: "арбитражный юрист {{city}}",
            },
            text: "В современных деловых отношениях и повседневной жизни граждане и организации сталкиваются с множеством правовых вопросов, требующих профессиональной юридической помощи. Разнообразие видов юридических услуг определяется областью права, характером отношений и сложностью обстоятельств. Решение таких задач требует глубоких знаний законодательства и практического опыта. Я предоставляю квалифицированную юридическую помощь по широкому спектру вопросов, не вошедших в другие разделы практики.",
            bulletPoints: [
              "Взыскание денежных средств по договору займа (расписка) и другим договорам — в судах общей юрисдикции и арбитражных судах",
              "Взыскание ущерба при заливе квартиры",
              "Признание гражданина безвестно отсутствующим, умершим или недееспособным",
              "Оспаривание действий и бездействий должностных лиц",
              "Установление юридических фактов",
              "Другие юридические вопросы",
            ],
            text2:
              "Кроме того, я предоставляю широкий спектр дополнительных юридических услуг, направленных на комплексное сопровождение клиентов:",
            services: [
              "Устные и письменные консультации",
              "Составление исковых заявлений, отзывов, возражений и жалоб (апелляционных, кассационных, надзорных)",
              "Составление претензий, заявлений и обращений в государственные и негосударственные организации",
              "Правовая экспертиза договоров и документов",
              "Составление договоров купли-продажи, дарения, мены, найма, включая сделки с ипотекой и материнским капиталом",
              "Правовая экспертиза документов при покупке недвижимости и земельных участков",
              "Помощь в приватизации жилья и земельных участков",
              "Получение кадастровых паспортов, регистрация сделок и прав собственности",
              "Полное сопровождение оформления наследства",
              "Иные юридические услуги по согласованию",
            ],
            button: "Другие услуги",
          },
        },
        price: {
          title: "Стоимость услуг юриста в Наро-Фоминске",
          description:
            "Примерная стоимость юридических услуг в Наро-Фоминске: консультации, составление договоров, ведение дел в суде и другие услуги.",
          keywords: {
            k1: "стоимость услуг юриста {{city}}",
            k2: "цены на юридические услуги {{city}}",
            k3: "консультация юриста {{city}}",
            k4: "составление договоров {{city}}",
            k5: "ведение дела в суде {{city}}",
          },
          text: "Стоимость услуг юриста зависит от сложности задачи и времени, необходимого для её решения. Примерные расценки: устная консультация — от 500 руб., письменная консультация — от 1000 руб., составление договоров — от 5000 руб., ведение дела в суде одной инстанции — от 18 000 руб. Индивидуальные условия возможны по согласованию. Свяжитесь для уточнения стоимости вашей услуги.",
          button: "Стоимость услуг",
        },
        about: {
          title:
            "О юристе Лапшиной Ирине Анатольевне – частная юридическая практика",
          description:
            "{{name}} – опытный частный юрист в Наро-Фоминске. Более 11 лет практики, специализация: гражданское, семейное, жилищное, трудовое право.",
          keywords: {
            k1: "{{name}}",
            k2: "частный юрист {{city}}",
            k3: "юридическая практика {{city}}",
            k4: "гражданское право {{city}}",
            k5: "семейное право {{city}}",
            k6: "жилищное право {{city}}",
          },
          text: "{{name}}, родилась 12 августа 1973 года. Высшее юридическое образование (РГСУ 1998-2003). Опыт юридической практики более 11 лет. Специализация: гражданское, семейное, жилищное, земельное, наследственное, трудовое право, защита прав потребителей, страховые споры, сопровождение сделок с недвижимостью, приватизация. Основной принцип работы — честность, индивидуальный подход и профессиональная защита интересов клиентов.",
        },
        contacts: {
          title: "Контакты юриста в Наро-Фоминске – {{name}}",
          description:
            "Свяжитесь с частным юристом в Наро-Фоминске: телефон, электронная почта, адрес офиса и схема проезда.",
          keywords: {
            k1: "контакты юриста {{city}}",
            k2: "телефон юриста {{city}}",
            k3: "почта юриста {{city}}",
            k4: "офис юриста {{city}}",
            k5: "схема проезда юрист {{city}}",
          },
          text: "Связаться со мной можно с понедельника по пятницу с 10:00 до 18:00 по телефону 8-916-332-82-59 или по электронной почте {{email}}. Офис расположен по адресу: город Наро-Фоминск, улица Ленина, дом 18. Прием ведется по предварительной записи. Схема проезда доступна на карте Яндекс.",
          button: "Контакты",
        },
      },
    },
  },
});

export default i18n;
